import themeGet from '@styled-system/theme-get';
import styled, { css } from 'styled-components';
import { compose, fontSize, space, width } from 'styled-system';
import { getPaletteColor } from '../utils/utils';
/**
 * @public
 */
export const tabSpacingSize = {
  xsm: '16px',
  sm: '24px',
  md: '32px',
  lg: '40px',
  xl: '48px'
};
/**
 * @public
 */
export const listStyles = ['disc', 'upper-roman', 'lower-roman', 'upper-alpha', 'lower-alpha', 'decimal', 'square', 'circle'];
const BaseCSS = /*#__PURE__*/css(["margin:", " 0;color:", ";& > li{margin:", " 0;}", " padding:0;list-style-type:", ";margin-left:", ";"], themeGet('space.1'), getPaletteColor('base'), themeGet('space.1'), props => compose(fontSize, space, width)(props), props => props.listStyle ? listStyles.includes(props.listStyle) ? props.listStyle : 'auto' : '', props => tabSpacingSize[props.indentSize ? props.indentSize : 'lg']);
const Ordered = /*#__PURE__*/styled('ol').withConfig({
  displayName: "List__Ordered",
  componentId: "sc-684k1l-0"
})(["& > li > *{margin-left:", ";}", ";"], themeGet('space.2'), BaseCSS);
const Unordered = /*#__PURE__*/styled('ul').withConfig({
  displayName: "List__Unordered",
  componentId: "sc-684k1l-1"
})(["", ";"], BaseCSS);
/**
 * @public
 */
export const List = Unordered;
List.ol = Ordered;
List.ol.displayName = 'OrderedList';
List.ul = Unordered;
List.ul.displayName = 'UnorderedList';